<div class="pagination flex w-full h-full gap-16 align-items-center table-pagination-div justify-content-between">
    <div class="flex align-items-centern flex-column w-full">
        <div class="flex align-items-center justify-content-center w-full">
            <div class="w-full">
                <span class="p-input-icon-left w-full">
                    <i class="pi pi-search"></i>
                    <input
                        #searchInput
                        class="w-22rem py-2 border-round-3xl"
                        pInputText
                        placeholder="{{ 'default-cm-search' | translate: 'Search' }}"
                        type="text"
                        [(ngModel)]="filters.searchKey"
                        (ngModelChange)="onKeywordChange($event)"
                        maxlength="52"
                    />
                </span>
            </div>
            <div class="flex flex-1 align-items-center justify-content-end gap-16">
                <span class="text-md white-space-nowrap">{{ 'default-cm-showBy' | translate: 'Show by' }}</span>
                <p-dropdown
                    optionValue="value"
                    [(ngModel)]="filters.pageSize"
                    [options]="pageSizeOptions"
                    optionLabel="viewValue"
                    [dropdownIcon]="dropdownIconClass"
                    (onShow)="onDropdownOpen()"
                    (onChange)="pageSizeChange.emit($event)"
                    (onHide)="onDropdownClose()"
                    appendTo="body"
                    styleClass="w-min py-1 text-sm line-height-1 pl-2 pr-0 text-medium  dropdown min-width-103"
                >
                </p-dropdown>
                <div class="flex align-items-center gap-1 text-sm justify-content-between min-width-110">
                    <!-- conditionaly render disabled or not -->
                    <i
                        [ngClass]="{ 'opacity-40 pointer-events-none': filters.pageSize * filters.page == 0 }"
                        class="pi pi-angle-left cursor-pointer pagination-arrow-icon"
                        (click)="changePage('decrement')"
                    ></i>
                    <span class="font-medium text-gray-300 white-space-nowrap"
                        >{{ filters.pageSize * filters.page + 1 }}
                        -
                        {{
                            filters.pageSize * (filters.page + 1) > filters.totalCount
                                ? filters.totalCount
                                : filters.pageSize * (filters.page + 1)
                        }}</span
                    >
                    <span class="text-primary-500">{{ 'default-cm-of' | translate: 'of' }}</span>
                    <span class="font-normal text-primary-500">{{ filters.totalCount }} </span>
                    <!-- conditionaly render disabled or not -->
                    <i
                        [ngClass]="{
                            'opacity-40 pointer-events-none':
                                filters.pageSize * (filters.page + 1) >= filters.totalCount ||
                                filters.totalCount < filters.pageSize,
                        }"
                        class="pi pi-angle-right cursor-pointer pagination-arrow-icon"
                        (click)="changePage('increment')"
                    ></i>
                </div>
            </div>
        </div>
    </div>
</div>
